import { Link2, Copy } from 'lucide-react';
import React from 'react';
import { Button } from '@/Components/shadcn/button';
import { cn } from '@/lib/utils';
import UIStrings from '@/Utils/UIStrings';

interface CopyLinkControlProps {
    link: string;
    onClickHandler: () => void;
    inputClassName?: string;
}

function CopyLinkControl({ link, onClickHandler, inputClassName }: CopyLinkControlProps): React.JSX.Element {
    return (
        <div className="flex flex-row flex-wrap gap-4 py-2.5" data-cy="recruitmentPublicLink">
            <div
                className={cn(
                    'border-input bg-card flex min-w-10 flex-1 items-center gap-2 rounded-xl border px-3.5 py-2',
                    inputClassName,
                )}
            >
                <Link2 className="text-muted-foreground size-4 shrink-0 self-center" aria-hidden />
                <a
                    href={link}
                    target="_blank"
                    rel="noreferrer"
                    title={link}
                    className="text-primary focus-visible:ring-primary min-w-0 text-sm leading-none break-all underline-offset-4 hover:underline focus-visible:rounded-sm focus-visible:ring-1 focus-visible:outline-none"
                >
                    {link}
                </a>
            </div>
            <Button type="button" variant="default" onClick={onClickHandler} className="shrink-0 gap-2">
                <Copy className="size-4" />
                {UIStrings.CopyLink}
            </Button>
        </div>
    );
}

export default CopyLinkControl;
